import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'
import router from './router'


if (process.env.VUE_APP_SERVE === 'true') {
  require('../../../static/bootstrap-5.3.2-dist/js/bootstrap.bundle.min.js');
  require('../../../static/bootstrap-5.3.2-dist/css/bootstrap.min.css');
  require('../../../static/css/base.css');
  require("../../../static/node_modules/bootstrap-icons/font/bootstrap-icons.css")
}

const app = createApp(App)

app.use(createPinia())
app.use(router)

app.mount('#app')

